/* PeekoraLab - Holiday conversion layer - 2026-10-27 (pairs with pk-holiday-cro.css)
   1. Delivery estimate + Christmas order-by line under the main Add to Cart.
   2. Bundle colour pickers side by side on phones (marks the panels).
   3. Sticky Add to Cart bar names the selected bundle + star rating.
   4. MagicReveal: opens on the Complete 4-Book Set (best value) unless the
      link already chose a book; the 3-book tier is hidden by CSS.
   5. Cart drawer: one-tap "Add a 2nd - 50% off" / "Add a 3rd - FREE" for
      products whose automatic Buy 2 / Buy 3 discounts really apply
      (verified in a test cart Oct 27). Gifts are still added by the
      existing offer script after the cart refreshes.
   Edit CHRISTMAS_CUTOFF below if the carrier cut-off changes. */
(function () {
  'use strict';
  if (window.__PK_HOLIDAY_CRO__) return;
  window.__PK_HOLIDAY_CRO__ = true;

  var CHRISTMAS_CUTOFF = new Date(2026, 11, 8, 23, 59); /* Dec 8, 2026 */
  var PROCESS = [1, 2], TRANSIT = [6, 10];
  var FR = String(document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    return 'CA$' + v.toFixed(2);
  }
  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ---------- 1. Delivery estimate ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) {
      r.setDate(r.getDate() + 1);
      var day = r.getDay();
      if (day !== 0 && day !== 6) n -= 1;
    }
    return r;
  }
  function fmt(d) {
    try {
      return d.toLocaleDateString(FR ? 'fr-CA' : 'en-CA', { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) { return d.toDateString(); }
  }
  function etaBox() {
    var now = new Date();
    var from = addBusinessDays(now, PROCESS[0] + TRANSIT[0]);
    var to = addBusinessDays(now, PROCESS[1] + TRANSIT[1]);
    var box = document.createElement('div');
    box.className = 'pkx-eta';
    box.setAttribute('data-pkx-eta', '');
    var rows = [];
    rows.push('<div class="pkx-eta__row"><span class="pkx-eta__ico" aria-hidden="true">🚚</span><span>' +
      (FR ? 'Commandez aujourd’hui, livraison prévue <b>' : 'Order today, arrives <b>') +
      fmt(from) + ' – ' + fmt(to) + '</b>' + (FR ? ' (suivi inclus)' : ' · tracked') + '</span></div>');
    var xmas = new Date(now.getFullYear(), 11, 24);
    if (now <= CHRISTMAS_CUTOFF && to <= xmas) {
      rows.push('<div class="pkx-eta__row pkx-eta__row--xmas"><span class="pkx-eta__ico" aria-hidden="true">🎄</span><span>' +
        (FR ? 'Arrive avant Noël — commandez d’ici le <b>8 décembre</b>' : 'Arrives before Christmas — order by <b>Dec 8</b>') + '</span></div>');
    } else if (now.getMonth() === 11 && now.getDate() < 24) {
      rows.push('<div class="pkx-eta__row pkx-eta__row--late"><span class="pkx-eta__ico" aria-hidden="true">🎄</span><span>' +
        (FR ? 'Pour Noël, écrivez à support@peekoralab.com avant de commander.' : 'Need it by Christmas? Email support@peekoralab.com before ordering.') + '</span></div>');
    }
    box.innerHTML = rows.join('');
    return box;
  }
  function placeEta() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('[data-pkx-eta]')) return;
    var sels = ['.pkcv__info .pkcv__add', '.pkmr__add', 'main [data-pkmr-add]', 'main form[action*="/cart/add"] button[type="submit"]'];
    var btn = null;
    for (var i = 0; i < sels.length && !btn; i++) {
      var list = document.querySelectorAll(sels[i]);
      for (var j = 0; j < list.length; j++) {
        if (list[j].offsetParent !== null && !list[j].closest('[class*="sticky"],.pkmc,.pq-collection,.pkh-card,.pkcv__mobile-bar')) { btn = list[j]; break; }
      }
    }
    if (!btn) return;
    var anchor = btn.closest('form') && btn.closest('form').parentElement !== btn.parentElement && btn.closest('.pkcv__info') === null ? btn.closest('form') : btn;
    /* Sit after the express-checkout block if it was mounted right below the button */
    var next = anchor.nextElementSibling;
    if (next && next.matches('[data-pk-pdp-express]')) anchor = next;
    anchor.insertAdjacentElement('afterend', etaBox());
  }

  /* ---------- 2. Side-by-side colour pickers ---------- */
  function markSlots() {
    document.querySelectorAll('.pkmr__tier-panel').forEach(function (p) {
      var n = p.querySelectorAll(':scope > .pkmr__slot').length;
      p.classList.toggle('pkx-slots-grid', n >= 2);
    });
  }

  /* ---------- 3. Sticky bar wording ---------- */
  function stickyLabel() {
    var tier = document.querySelector('[data-pkbb-tier].is-active, [data-pkmr-tier].is-active');
    if (!tier) return '';
    var titleEl = tier.querySelector('.pkim-title-row strong, .pkcv__tier-copy strong');
    var title = titleEl ? titleEl.textContent.trim() : '';
    title = title.replace(/\s+—\s+(Sibling|Grandkids) Pack$/i, '').replace(/\s+—\s+2nd 50% off$/i, '').replace(/\s+—\s+3rd FREE$/i, '');
    var qty = Number(tier.getAttribute('data-qty') || 1);
    var mode = tier.getAttribute('data-mode') || '';
    var gift = '';
    if (tier.hasAttribute('data-pkbb-tier') && qty >= 2 && document.querySelector('[data-pkbb-root][data-product-handle="peekorascope-explorer-kids-microscope"]')) gift = FR ? ' + MiniScope OFFERT' : ' + FREE MiniScope';
    if (tier.hasAttribute('data-pkmr-tier') && mode === 'set') gift = FR ? ' + pinceau OFFERT' : ' + FREE brush';
    var badge = document.querySelector('.pkcv__info .jdgm-prev-badge[data-average-rating], main .jdgm-prev-badge[data-average-rating]');
    var rating = badge ? Number(badge.getAttribute('data-average-rating')) : 0;
    var stars = rating >= 4 ? '★ ' + rating.toFixed(1) + ' · ' : '';
    return stars + title + gift;
  }
  function syncSticky() {
    var bar = document.querySelector('.pkcv__mobile-bar');
    if (!bar) return;
    var small = bar.querySelector('small');
    if (!small) return;
    var label = stickyLabel();
    if (label && small.textContent !== label) small.textContent = label;
  }
  function watchSticky() {
    var bar = document.querySelector('.pkcv__mobile-bar');
    if (!bar || !('MutationObserver' in window)) return;
    var run = debounce(syncSticky, 30);
    new MutationObserver(run).observe(bar, { childList: true, subtree: true, characterData: true });
    var tiers = document.querySelector('.pkcv__tiers, .pkcv__bundle');
    if (tiers) tiers.addEventListener('click', function () { setTimeout(syncSticky, 80); setTimeout(syncSticky, 400); });
    syncSticky();
  }

  /* ---------- 4. MagicReveal: default to the 4-Book Set ---------- */
  function mrDefaultSet() {
    var root = document.querySelector('[data-pkmr-root][data-product-handle="peekora-magicreveal-water-coloring-book"]');
    if (!root) return;
    document.body.classList.add('pkx-mr');
    /* The intro line still offered "2 or 3" books; the 3-book tier is hidden now */
    var guide = root.querySelector('.pkmr__offer-guide');
    if (guide) {
      var walker = document.createTreeWalker(guide, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/2 or 3/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/Choose 2 or 3 to mix and match/i, 'Choose 2 to mix and match').replace(/2 or 3/, '2');
        if (/2 ou 3/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/2 ou 3/, '2');
      }
    }
    if (/[?&]variant=/.test(location.search)) return;
    var set = root.querySelector('[data-pkmr-tier][data-mode="set"]');
    if (!set || set.classList.contains('is-active')) return;
    var head = set.querySelector('.pkmr__tier-head, button');
    if (head) head.click();
  }

  /* ---------- 5. Cart drawer upsell ---------- */
  var UPSELL = {
    'peekorascope-explorer-kids-microscope': { en: 'Explorer', fr: 'Explorer', gift2: ['FREE MiniScope', 'MiniScope OFFERT'] },
    'peekora-magicreveal-water-coloring-book': { en: 'book', fr: 'livre', varied: true },
    'microscope-60-120x-lab-handheld-microscope-battery-powered-microscope-with-led-light-kids-science-microscope': { en: 'MiniScope', fr: 'MiniScope' },
    'peekora-colornest-color-sorting-toy': { en: 'ColorNest', fr: 'ColorNest' },
    'peekoratalk-reader-bilingual-book': { en: 'TalkReader', fr: 'TalkReader' },
    'peekora-prismatch-rainbow-matching-game': { en: 'PrismMatch', fr: 'PrismMatch' },
    'peekora-nestwood-wooden-puzzle': { en: 'FitNest', fr: 'FitNest', gift2: ['FREE PrismMatch', 'PrismMatch OFFERT'] }
  };
  var productCache = {};
  var upsellBusy = false;

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function pickOffer(cart) {
    var counts = {}, best = null;
    (cart.items || []).forEach(function (it) {
      var cfg = UPSELL[it.handle];
      if (!cfg) return;
      if (!it.original_price) return;
      if (/set|complete/i.test(it.variant_title || '')) return; /* 4-Book Set has its own gift deal */
      if (it.properties && (it.properties._gift || it.properties._pk_gift)) return;
      if (Number(it.final_line_price) === 0) return; /* free gift lines */
      var c = counts[it.handle] || (counts[it.handle] = { qty: 0, item: it, variants: [] });
      c.qty += it.quantity;
      c.variants.push(it.variant_id);
      if (it.original_price > c.item.original_price) c.item = it;
    });
    Object.keys(counts).forEach(function (h) {
      var c = counts[h];
      if (c.qty !== 1 && c.qty !== 2) return;
      if (!best || c.item.original_price > best.item.original_price) best = { handle: h, qty: c.qty, item: c.item, inCart: c.variants };
    });
    return best;
  }

  function offerHtml(o, variantTitle) {
    var cfg = UPSELL[o.handle];
    var name = FR ? cfg.fr : cfg.en;
    var unit = o.item.original_price;
    var third = o.qty === 2;
    var priceText = third ? (FR ? 'GRATUIT' : 'FREE') : money(Math.round(unit / 2));
    var head = third
      ? (FR ? 'Ajoutez un 3e ' + name + ' — GRATUIT' : 'Add a 3rd ' + name + ' — FREE')
      : (FR ? 'Ajoutez un 2e ' + name + ' — 50 % de rabais' : 'Add a 2nd ' + name + ' — 50% off');
    var sub = cfg.gift2 && !third ? (FR ? '+ ' + cfg.gift2[1] + ' · ' : '+ ' + cfg.gift2[0] + ' · ') : '';
    sub += variantTitle ? variantTitle + ' · ' : '';
    sub += FR ? 'Un pour chaque enfant · appliqué automatiquement' : 'One for each child · applied automatically';
    return '<div class="pkx-up__txt"><strong>' + head + '</strong><small>' + sub + '</small></div>' +
      '<button type="button" class="pkx-up__btn" data-pkx-up-add>' + (FR ? 'Ajouter · ' : 'Add · ') + priceText + '</button>';
  }

  function renderUpsell() {
    var drawer = document.querySelector('.pkmc');
    if (!drawer) return;
    var body = drawer.querySelector('.pkmc__body');
    if (!body) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var existing = body.querySelector('[data-pkx-up]');
      var o = pickOffer(cart);
      var progress = body.querySelector('[data-pkmc-bundle-progress]');
      if (!o) {
        if (existing) existing.remove();
        if (progress) progress.classList.remove('pkx-hide');
        return;
      }
      var cfg = UPSELL[o.handle];
      var pickVariant = Promise.resolve({ id: o.item.variant_id, title: '' });
      if (cfg.varied) {
        pickVariant = getProduct(o.handle).then(function (p) {
          if (!p) return { id: o.item.variant_id, title: '' };
          var free = p.variants.filter(function (v) {
            return v.available && !/set|complete/i.test(v.title) && o.inCart.indexOf(v.id) === -1;
          });
          var v = free[0];
          return v ? { id: v.id, title: v.title } : { id: o.item.variant_id, title: '' };
        });
      }
      return pickVariant.then(function (v) {
        var key = o.handle + ':' + o.qty + ':' + v.id;
        if (existing && existing.getAttribute('data-pkx-up') === key) return;
        var box = existing || document.createElement('div');
        box.className = 'pkx-up';
        box.setAttribute('data-pkx-up', key);
        box.setAttribute('data-variant', String(v.id));
        box.innerHTML = offerHtml(o, v.title);
        if (!existing) {
          var firstItem = body.querySelector('[data-pkmc-items]') || body.firstElementChild;
          if (progress) progress.insertAdjacentElement('afterend', box);
          else if (firstItem) firstItem.insertAdjacentElement('afterend', box);
          else body.insertAdjacentElement('afterbegin', box);
        }
        /* The older progress box only had a "Start exploring" link - the new row replaces its job */
        if (progress) progress.classList.add('pkx-hide');
      });
    }).catch(function () {});
  }

  function bindUpsellClicks() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pkx-up-add]');
      if (!btn || upsellBusy) return;
      e.preventDefault();
      var box = btn.closest('[data-pkx-up]');
      var id = Number(box && box.getAttribute('data-variant'));
      if (!id) return;
      upsellBusy = true;
      btn.disabled = true;
      btn.textContent = FR ? 'Ajout…' : 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function () {
        if (window.PeekoraMiniCart && typeof window.PeekoraMiniCart.refresh === 'function') {
          return window.PeekoraMiniCart.refresh();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () {}).then(function () {
        upsellBusy = false;
        setTimeout(renderUpsell, 400);
        setTimeout(renderUpsell, 1500);
      });
    });
  }

  function watchCart() {
    var drawer = document.querySelector('.pkmc');
    if (!drawer || !('MutationObserver' in window)) return;
    var items = drawer.querySelector('[data-pkmc-items]') || drawer;
    var run = debounce(renderUpsell, 250);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest('[data-pkx-up]')) continue;
        run(); return;
      }
    }).observe(items, { childList: true, subtree: true });
    new MutationObserver(function () { if (drawer.classList.contains('is-open')) run(); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (drawer.classList.contains('is-open')) run();
  }

  /* ---------- boot ---------- */
  function boot() {
    mrDefaultSet();
    placeEta();
    markSlots();
    watchSticky();
    bindUpsellClicks();
    watchCart();
    var tiers = document.querySelector('.pkcv__tiers, .pkcv__bundle');
    if (tiers) {
      tiers.addEventListener('click', function () { setTimeout(markSlots, 60); setTimeout(markSlots, 400); });
    }
    setTimeout(function () { placeEta(); markSlots(); syncSticky(); }, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
